export default __webpack_public_path__ + "static/media/Waterlevel.edad3fb6.png";